/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "geocode": {
            "nested": {
              "Geocode": {
                "fields": {
                  "latitude": {
                    "type": "double",
                    "id": 1,
                    "rule": "optional"
                  },
                  "longitude": {
                    "type": "double",
                    "id": 2,
                    "rule": "optional"
                  },
                  "resolution": {
                    "type": ".squareup.common.geocode.Geocode.Resolution",
                    "id": 3,
                    "rule": "optional"
                  },
                  "accuracy": {
                    "type": "double",
                    "id": 4,
                    "rule": "optional"
                  },
                  "altitude": {
                    "type": "double",
                    "id": 5,
                    "rule": "optional"
                  },
                  "altitudeAccuracy": {
                    "type": "double",
                    "id": 6,
                    "rule": "optional"
                  },
                  "heading": {
                    "type": "double",
                    "id": 7,
                    "rule": "optional"
                  },
                  "speed": {
                    "type": "double",
                    "id": 8,
                    "rule": "optional"
                  },
                  "debugInfo": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "geocodedAt": {
                    "type": "int64",
                    "id": 10,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Resolution": {
                    "values": {
                      "UNKNOWN": 0,
                      "ADMINISTRATIVE_AREA": 2,
                      "LOCALITY": 4,
                      "SUB_LOCALITY": 6,
                      "POSTAL_CODE": 8,
                      "BLOCK": 10,
                      "THOROUGHFARE": 12,
                      "THOROUGHFARE_SEGMENT": 14,
                      "INTERPOLATED_PREMISES": 16,
                      "PREMISES": 18,
                      "SUBPREMISES": 20,
                      "MANUAL": 31
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.geocode?.nested?.Geocode && !$root.nested?.squareup?.nested?.common?.nested?.geocode?.nested?.Geocode?.nested?.Resolution) {
  $root.addJSON(jsonData);
}

/**
 * Geocode of a location, which might be from an address, GPS coordinates, or other sources.  The
 * estimates of accuracy/precision/resolution are different depending on the source.
 *
 * SOURCE Geocode @ squareup/common/geocode.proto at 9:1
 */
export const Geocode = $root.lookupType('squareup.common.geocode.Geocode');
fixType(Geocode);
Builder.createAndAttachToType(Geocode);
/**
 * SOURCE Resolution @ squareup/common/geocode.proto at 48:3
 */
Geocode.Resolution = $root.lookupEnum('squareup.common.geocode.Geocode.Resolution').values;